import * as Yup from "yup";

export const registrationFormFields = [
  { name: "first_name", type: "text", placeholder: "First Name" },
  { name: "last_name", type: "text", placeholder: "Last Name" },
  { name: "email", type: "email", placeholder: "Email" },
  { name: "password", type: "password", placeholder: "Create Password" },
  { name: "password2", type: "password", placeholder: "Retype Password" },
];

export const registrationInitialValues = {
  first_name: "",
  last_name: "",
  email: "",
  mobile_country_code: "+971",
  mobile_number: "",
  mobile: "", // derived before submit for backend compatibility
  password: "",
  password2: "",
  user_type: "freelancers",
  company_name: "",
  location_city: "",
  location_country: "",
  location: "",
  otp_code: "",
};

export const validationSchema = Yup.object().shape({
  first_name: Yup.string()
    .test(
      "no-only-spaces",
      "First name cannot be empty or only spaces",
      (value) => value?.trim().length > 0,
    )
    .required("First name is required"),
  last_name: Yup.string()
    .test(
      "no-only-spaces",
      "Last name cannot be empty or only spaces",
      (value) => value?.trim().length > 0,
    )
    .required("Last name is required"),
  email: Yup.string()
    .email("Invalid email")
    .test(
      "no-only-spaces",
      "Email cannot be empty or only spaces",
      (value) => value?.trim().length > 0,
    )
    .required("Email is required"),
  mobile_country_code: Yup.string()
    .required("Country code is required")
    .matches(/^\+\d{1,5}$/, "Invalid country code"),
  mobile_number: Yup.string()
    .required("Phone number is required")
    .test(
      "no-only-spaces",
      "Phone number cannot be empty or only spaces",
      (value) => value?.trim().length > 0,
    )
    .matches(/^\d{7,14}$/, "Phone number must be 7–14 digits"),
  password: Yup.string()
    .min(12, "Password must be at least 12 characters")
    .matches(
      /(?=.*[A-Z])/,
      "Password must contain at least one uppercase letter",
    )
    .matches(/(?=.*\d)/, "Password must contain at least one number")
    .matches(
      /(?=.*[!@#$%^&*()_\-+={}[\]|\\:;"'<>,.?/~`])/,
      "Password must contain at least one special character",
    )
    .test(
      "no-only-spaces",
      "Password cannot be empty or only spaces",
      (value) => value?.trim().length > 0,
    )
    .required("Password is required"),
  password2: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .test(
      "no-only-spaces",
      "Confirm password cannot be empty or only spaces",
      (value) => value?.trim().length > 0,
    )
    .required("Confirm password is required"),
  user_type: Yup.string()
    .oneOf(["freelancers", "business"], "Invalid role selection")
    .required("Role is required"),
  company_name: Yup.string().when("user_type", {
    is: "business",
    then: (schema) =>
      schema
        .test(
          "no-only-spaces",
          "Company name cannot be empty or only spaces",
          (value) => value != null && String(value).trim().length > 0,
        )
        .required("Company name is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
  nationality: Yup.string().notRequired(),
  location: Yup.string().required("Location is required"),
  // SMS verification disabled temporarily
  // otp_code: Yup.string().length(6, "Enter the 6-digit SMS code").required("SMS verification code is required"),
});
